export default __webpack_public_path__ + "static/flipImg3-9c107d402a2547149325a34096e86061.webp";